
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.956 8.57a18.289 18.289 0 01-5.293 1.45 9.249 9.249 0 004.053-5.096 18.452 18.452 0 01-5.85 2.235 9.21 9.21 0 00-6.73-2.909 9.212 9.212 0 00-9.212 9.213c0 .722.08 1.427.238 2.1-7.658-.384-14.447-4.052-18.993-9.627a9.187 9.187 0 00-1.247 4.633 9.215 9.215 0 004.098 7.67 9.186 9.186 0 01-4.172-1.152l-.001.115a9.22 9.22 0 007.39 9.036 9.274 9.274 0 01-4.159.16 9.226 9.226 0 008.606 6.398 18.483 18.483 0 01-11.441 3.946c-.745 0-1.479-.043-2.199-.13a26.1 26.1 0 0014.124 4.138c16.947 0 26.217-14.04 26.217-26.217 0-.399-.011-.797-.028-1.193a18.693 18.693 0 004.599-4.77z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    